import { MoreMenu } from 'components/MoreMenu';
import { lodash } from 'helpers';
import { TFunc } from 'libs/i18n';
import { Icon } from 'libs/ui/Icon';

import {
  DirectoryRecordItemType,
  DirectoryRecordOptionType,
} from '../../../types';

interface Actions {
  onClickArchive?: (item: DirectoryRecordItemType) => void;
  onClickDearchive?: (item: DirectoryRecordItemType) => void;
}

export const renderMore = (
  t: TFunc,
  item: DirectoryRecordItemType,
  { onClickArchive, onClickDearchive }: Actions
) => {
  const onClickOption = (option: DirectoryRecordOptionType) => {
    switch (option) {
      case DirectoryRecordOptionType.archive:
        onClickArchive?.(item);
        break;
      case DirectoryRecordOptionType.dearchive:
        onClickDearchive?.(item);
        break;
      default:
        break;
    }
  };
  const options = lodash.compact([
    !item.isArchived &&
      item.isArchivable &&
      onClickArchive && {
        value: DirectoryRecordOptionType.archive,
        label: t('common.archive'),
        Icon: Icon.TimeSleep,
      },
    item.isArchived &&
      onClickDearchive && {
        value: DirectoryRecordOptionType.dearchive,
        label: t('common.dearchive'),
        Icon: Icon.RotateRightCheck,
      },
  ]);

  if (!options.length) {
    return null;
  }

  return (
    <MoreMenu
      options={options}
      variant="horizontal"
      onClickOption={(option) => onClickOption(option.value)}
    />
  );
};
